// 繁體中文表格（機器翻譯，未經人工審校 — ruling G4）。
// The Traditional Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  styleGroup: "杯墊風格",
  styles: {
    two: "雙面",
    logo: "名字 / 標誌",
  },
  titles: {
    two: "雙面杯墊",
    logo: "帶標誌的杯墊",
  },
  textHint: (lines, chars) => `最多 ${lines} 行，每行至多 ${chars} 個字元`,
  needFile: "選擇標誌的 SVG 檔案——它只留在您的裝置上，不會傳送到任何地方",
  artKept: "標誌只存在於目前分頁——重新整理後需重新選擇檔案",
  keptOld: "（仍在使用先前的標誌）",
  thumb: "已讀取標誌的預覽",
  finish: "標誌風格",
  finishes: {
    flush: "齊平",
    raised: "凸起",
    engraved: "雕刻",
  },
  finishNote: {
    flush: "與表面齊平；標誌為第二種顏色——需要多色印表機和 3MF 檔案（STL 不含標誌，為閉合體）",
    raised: (mm) => `凸起 ${mm} 公厘——單噴頭印表機換一次料即可得到兩種顏色（在「列印」下選「單噴頭」）。標誌較窄時杯子可能放不穩`,
    engraved: (mm) => `雕刻 ${mm} 公厘深——單色，無需換料`,
  },
  flushNeedsMulti: "齊平效果無法用單噴頭列印——請選多色列印",
  scale: "標誌大小",
  logoColour: "標誌顏色",
  logoPartNames: {
    body: "杯墊主體",
    message: "標誌",
  },
  logoZNames: {
    body: "主體顏色",
    message: "標誌顏色",
  },
  logoEdgeNote: {
    lip: (mm) => `高出表面 ${mm} 公厘的邊能擋住飲品`,
    flat: "無邊——同一平面",
  },
  gShape: "形狀與邊緣",
  gColour: "顏色與列印",
  a: "A 面詞語",
  b: "B 面詞語",
  wordHint: "B 面朝向對面的人；詞語越短越清晰——不超過 6 個字元",
  rows: (n) => `${Math.floor(n)} 行`,
  shape: "形狀",
  shapes: {
    round: "圓形",
    square: "方形",
  },
  views: {
    a: "A 面",
    b: "B 面",
    top: "從上方看",
  },
  d: {
    round: "直徑",
    square: "寬度",
  },
  mm: (v) => `${v} 公厘`,
  edge: "邊緣",
  edges: {
    lip: "凸邊",
    flat: "平邊",
  },
  edgeNote: {
    lip: "邊緣高出台面 1.2 公厘，能擋住飲品",
    flat: "邊緣與台面齊平——飲品落在凹槽裡",
  },
  looks: "顏色主題",
  lookNames: {
    night: "夜色",
    bee: "黑黃",
    wood: "木紋",
  },
  colour: {
    body: "杯墊主體顏色",
    message: "文字顏色",
  },
  mode: "列印",
  modes: {
    multi: "多色（CFS / AMS）",
    swap: "單噴頭，按層換色",
  },
  modeNote: {
    multi: "3MF 有 2 個零件——請在切片軟體裡分別設定顏色",
    swap: (z1, z2) => `以 0.2 公厘層高列印，並依圖下方所示安排換料（在零件的 ${z1} 和 ${z2} 公厘處換色）`,
    swapOne: (layer, z) => `以 ${layer} 公厘層高列印，並依圖下方所示安排換料（在零件的 ${z} 公厘處換色）`,
    lipToo: "凸邊也會用標誌的顏色列印",
    oneColour: "單色——無需設定換色",
  },
  zLine: (layer, filament, name) => `第 ${layer} 層之前，裝入 ${filament}（${name}）`,
  partNames: {
    body: "杯墊主體",
    message: "文字",
  },
  zNames: {
    body: "主體顏色",
    message: "文字顏色",
  },
  size: (shape, d, h) => (shape === 'round' ? `Ø ${d} × ${h} 公厘` : `${d} × ${d} × ${h} 公厘`),
  hold: (ml) => `約可盛 ${Math.round(ml)} 毫升`,
  loadingFont: (family, got, total) => (total > 0 ? `正在載入 ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `正在載入 ${family} ${got.toFixed(1)} MB`),
  problem: {
    "few-rows-a": "A 面詞語太長——字母行數少、難以辨認；請換短一些的詞",
    "few-rows-b": "B 面詞語太長——字母行數少、難以辨認；請換短一些的詞",
    "light-body": "杯墊主體應比文字深，否則文字不顯眼",
    "thin-text": "字母很細——有些筆畫可能列印不出來；請用更大的標誌或減少字元",
    "same-colour": "標誌顏色與杯墊主體相同——標誌將看不到",
    "thin-parts": "標誌的細筆畫連著厚實部分——切片軟體可能把它們切掉",
    dropped: (p) => `已從標誌中捨棄 ${p.n} 個過薄、無法列印的部分`,
    "all-thin": "標誌對這個尺寸來說太薄——無法下載",
    "art-too-complex": "標誌太複雜——無法下載",
  },
  dlstl: "STL",
  copied: "已複製",
  fatal: "無法載入計算器——請嘗試重新整理頁面",
  buildTimeout: "產生 10 秒未完成，已重新開始——請減少字元或換字型",
  beta: "測試版",
  aboutH2: "雙面杯墊的原理",
  aboutP1: "杯墊凸起的筋下面藏著一層顏色：坐在 A 側的人看到一個詞，對面的人看到另一個。正上方看不出文字。模擬顯示離約 40–100 公分時最易讀。",
  aboutP2: "用 0.2 公厘層高列印。本體用深色、文字用亮色；筋之間的溝槽防止杯子黏住並兜住水滴 — 用完把水擦掉。",
  aboutPrintNote: "這款設計已通過光照和切片模擬，等待實際列印驗證。",
  aboutLogoP: "「名字 / 標誌」款是平面杯墊：可放文字或店裡的 SVG 標誌檔案，平滑、凸起或雕刻任選。標誌檔案只留在你的裝置上，不會被傳送到任何地方。注意：比噴嘴還細的線條或筆畫間隙可能被切片軟體丟掉或列印後黏在一起 — 列印前先在切片軟體裡確認。這款在 OrcaSlicer 裡做過切片驗證，還未實測列印。",
  // the words a page opened with no link starts on (R69): the English words — no bundled family has kana or Han
  start: {
    a: "Cheers",
    b: "LOVE",
  },
};
export default S;
